import { render, staticRenderFns } from "./ResultStudentVarious.vue?vue&type=template&id=e0f5f9e4&scoped=true&"
import script from "./ResultStudentVarious.vue?vue&type=script&lang=ts&"
export * from "./ResultStudentVarious.vue?vue&type=script&lang=ts&"
import style0 from "./ResultStudentVarious.vue?vue&type=style&index=0&id=e0f5f9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f5f9e4",
  null
  
)

export default component.exports